import { render, staticRenderFns } from "./IconDairy.vue?vue&type=template&id=0396e506&"
import script from "./IconDairy.vue?vue&type=script&lang=ts&"
export * from "./IconDairy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports